import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import BulkAccountCreation from "../components/accounts/bulkCreation/BulkAccountCreation";

export default function AdminBulkAccountCreationPage() {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <BulkAccountCreation />;
}
